import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export type SlidesAiEditFirstWriteCommandProperties = CommandProperties & {
	editRequestId: string;
	editActionId: string;
	/** performance.timeOrigin + performance.now() at the first effective deck write. */
	firstAppliedAt: number;
};

export type SlidesAiEditActionCompletedCommandProperties = CommandProperties & {
	editRequestId: string;
	editActionId: string;
	status: 'success' | 'failure' | 'cancelled';
	/** Canvas application completion, excluding bridge delivery and trailing responses. */
	completedAt: number;
	firstAppliedAt?: number;
	/** Cumulative distinct counts across every action in this request, on this receiver. */
	affectedSlideCount: number;
	changedChildElementCount: number;
};

export const SlidesAiEditFirstWriteCommand: CommandConstructor<
	SlidesAiEditFirstWriteCommandProperties,
	void
> = createCommand<SlidesAiEditFirstWriteCommandProperties, void>('slides-ai-edit-first-write');
export const SlidesAiEditActionCompletedCommand: CommandConstructor<
	SlidesAiEditActionCompletedCommandProperties,
	void
> = createCommand<SlidesAiEditActionCompletedCommandProperties, void>(
	'slides-ai-edit-action-completed',
);
